import Vue from 'vue';
import VueNativeSock from 'vue-native-websocket';

import store from '@/store/index';

export default function (mutationName, marketName, fiatCode) {
  Vue.use(VueNativeSock, _getFullUrl(marketName, fiatCode), {
    connectManually: true,
    store: store,
    mutations: {
      SOCKET_ONOPEN: mutationName + '/SOCKET_ONOPEN',
      SOCKET_ONCLOSE: mutationName + '/SOCKET_ONCLOSE',
      SOCKET_ONERROR: mutationName + '/SOCKET_ONERROR',
      SOCKET_ONMESSAGE: mutationName + '/SOCKET_ONMESSAGE',
      SOCKET_RECONNECT: mutationName + '/SOCKET_RECONNECT',
    },
    format: 'json',
    reconnection: true,
    reconnectionAttempts: 3,
  });
  Vue.prototype.$connect();
  Vue.prototype.$connectToPrice = (market, fiat) => {
    const url = _getFullUrl(market, fiat);
    Vue.prototype.$connect(url);
  };
}

function _getFullUrl (marketName, fiatCode) {
  const basePath = SEO_API_WS_URL; // eslint-disable-line no-undef
  return `${basePath}?market=${marketName}&fiat=${fiatCode}`;
}
